module.exports = __webpack_public_path__ + "static/media/main idea.d05bc4e9.mp3";